<!--
 * @Version: 1.2
 * @Author: admin
 * @Description: navbar
 * @Date: 2022-06-23 14:44:40
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 11:39:13
-->
<template>
  <div class="navbar">
    <div class="left-side">
      <a-space>
        <!-- <img alt="logo" :src="logo" style="height: 40px" /> -->
        <a-typography-title class="title" :style="{ margin: 0, fontSize: '18px' }" :heading="5">
          <img src="@/assets/images/login/logo.png" style="height: 24px;width: 24px;margin-right: 10px"/>
          军人体能训练管理考核系统 <span v-if="barrackName">|&nbsp;{{ barrackName }}</span>
        </a-typography-title>
        <!-- <icon-menu-fold
          v-if="appStore.device === 'mobile'"
          style="font-size: 22px; cursor: pointer"
          @click="toggleDrawerMenu"
        /> -->
      </a-space>
    </div>
    <ul class="right-side">
      <li>
        <div class="message-box-trigger">
          <a-button class="nav-btn"  type="primary" @click="setPopoverVisible">
            <icon-file/>
            文件管理助手
          </a-button>
        </div>
        <a-popover
            trigger="click"
            :arrow-style="{ display: 'none' }"
            :content-style="{ padding: 0, minWidth: '400px' }"
            content-class="message-popover"
        >
          <div ref="refBtn" class="ref-btn"></div>
          <template #content>
            <file-box/>
          </template>
        </a-popover>
      </li>
      <li v-if="!barrackId && !loginBarrackId">
        <a-dropdown>
          <a-button class="nav-btn" type="primary" @click="enterUnit"> 进入营区</a-button>

          <!--禁用自动填充密码-->
          <input type="text" placeholder="请输账户" class="fake-input" style="display: none"/>
          <input type="password" placeholder="请输密码" class="fake-input" style="display: none"/>

          <template #content>
            <a-select
                :style="{ width: '220px' }"
                placeholder="搜索营区"
                allow-search
                :bordered="false"
                :default-popup-visible="true"
                allow-clear
                @change="selectUnit"
                popupVisible
            >
              <a-option v-for="item in project" :key="item.id" :value="item.id">{{ item.barrackName }}</a-option>
            </a-select>
          </template>
        </a-dropdown>
      </li>
      <li v-if="!barrackId && loginBarrackId">
        <a-button class="nav-btn" type="primary" @click="exitUnit"> 退出营区</a-button>
      </li>
      <!-- <li>
        <a-tooltip :content="theme === 'light' ? '暗黑' : '明亮'">
          <a-button class="nav-btn" type="outline" :shape="'circle'" @click="toggleTheme()">
            <template #icon>
              <icon-moon-fill v-if="theme === 'dark'" />
              <icon-sun-fill v-else />
            </template>
          </a-button>
        </a-tooltip>
      </li> !-->

      <li>
        <a-dropdown trigger="click">
          <a-avatar
              :size="32"
              :style="{ marginRight: '8px', cursor: 'pointer', verticalAlign: 'middle', backgroundColor: '#168cff' }"
          >
            <img alt="avatar" :src="avatar" v-if="avatar"/>
            <IconUser v-else/>
          </a-avatar>
          {{ userName }}
          <template #content>
            <a-doption>
              <a-space @click="userCenter">
                <icon-user/>
                <span> 个人中心 </span>
              </a-space>
            </a-doption>
            <a-doption>
              <a-space @click="handleLogout">
                <icon-export/>
                <span> 退出 </span>
              </a-space>
            </a-doption>
          </template>
        </a-dropdown>
      </li>
    </ul>
    <a-modal :simple="true" v-model:visible="logoutVisible" @cancel="cancel" @ok="logoutOk">
      <template #title> 退出</template>
      <div class="text-c">确认退出系统吗？</div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import {computed, ref, inject, watch, onMounted, nextTick} from "vue";
import {Message} from "@arco-design/web-vue";
import {useDark, useToggle} from "@vueuse/core";
import {useAppStore, useUserStore} from "@/store";
import {useRouter} from "vue-router";
import useUser from "@/hooks/user";
import {setSessionLoginSchooId, quitSessionLoginSchooId} from "@/api/user";
import {setToken} from "@/utils/auth";
import useLoading from "@/hooks/loading";
import FileBox from './file-box.vue';

const appStore = useAppStore();
const userStore = useUserStore();
const router = useRouter();
const schoolName = ref("");
const isReadonly = ref(true);
const select = ref<HTMLDivElement>();
let showName = ref(false);
const {logout} = useUser();
const logoutVisible = ref(false);
const {loading, setLoading} = useLoading(false);
const avatar = computed(() => {
  return userStore.avatar || "";
});
const logo = require("@/assets/logo.jpg");
const gohome = () => {
  router.replace({name: "home"});
};
const userName = computed(() => {
  return userStore.nickName;
});
const isAdmin = computed(() => {
  return userStore.admin;
});
const barrackId = computed(() => {
  return userStore.barrackId;
});
const barrackName = computed(() => {
  return userStore.barrackName;
});
const loginBarrackId = computed(() => {
  return userStore.loginBarrackId;
});
const project = computed(() => {
  return userStore.project;
});
const theme = computed(() => {
  return appStore.theme;
});
const isDark = useDark({
  selector: "body",
  attribute: "arco-theme",
  valueDark: "dark",
  valueLight: "light",
  storageKey: "arco-theme",
  onChanged(dark: boolean) {
    // overridded default behavior
    appStore.toggleTheme(dark);
  },
});
const toggleTheme = useToggle(isDark);
const setVisible = () => {
  appStore.updateSettings({globalSettings: true});
};
const enterUnit = () => {
};
const refBtn = ref();
const triggerBtn = ref();
const setPopoverVisible = () => {
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  refBtn.value.dispatchEvent(event);
};
const refreshAll = () => {
  appStore.setHasRoutes(false);
  setLoading(false);
  window.location.href = window.location.origin + "/web/";
};
const selectUnit = (val) => {
  setLoading(true);
  setSessionLoginSchooId(val)
      .then((response) => {
        userStore.setLoginBarrackId(val);
        let barrackName = project.value.filter((i) => i.id == val)[0].barrackName;
        userStore.setBarrackName(barrackName);
        setToken(response.token);
        setTimeout(() => {
          refreshAll();
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Message.error("进入军区失败，请联系客服，错误原因：" + error);
      });
};

const exitUnit = () => {
  setLoading(true);
  quitSessionLoginSchooId()
      .then((response) => {
        userStore.setLoginBarrackId("");
        userStore.setBarrackName("");
        setToken(response.token);
        setTimeout(() => {
          refreshAll();
        });
      })
      .catch((error) => {
        setLoading(false);
        Message.error("退出军区失败，请联系客服，错误原因：" + error);
      });
};
const handleLogout = () => {
  logoutVisible.value = true;
};
const logoutOk = () => {
  logoutVisible.value = false;
  logout().then((res) => {
    appStore.setHasRoutes(false);
    router.replace({name: "login"});
  });
};
const cancel = () => {
  logoutVisible.value = false;
};
const setDropDownVisible = () => {
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  triggerBtn.value.dispatchEvent(event);
};
const userCenter = () => {
  router.push("/userCenter");
};
const switchRoles = async () => {
  const res = await userStore.switchRoles();
  Message.success(res as string);
};
const toggleDrawerMenu = inject("toggleDrawerMenu");
</script>

<style scoped lang="less">
.navbar {
  display: flex;
  justify-content: space-between;
  height: 100%;
  color: #fff;
  background-color: #0F3366;
  //border-bottom: 1px solid var(--color-border);
}

.left-side {
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.right-side {
  display: flex;
  padding-right: 20px;
  list-style: none;

  :deep(.locale-select) {
    border-radius: 20px;
  }

  li {
    display: flex;
    align-items: center;
    padding: 0 10px;
  }

  a {
    color: var(--color-text-1);
    text-decoration: none;
  }

  .nav-btn {
    font-size: 16px;
  }

  .trigger-btn,
  .ref-btn {
    position: absolute;
    bottom: 14px;
  }

  .trigger-btn {
    margin-left: 14px;
  }
}

.title {
  display: flex;
  align-items: center;
  color: #fff;
}
</style>

<style lang="less">
.message-popover {
  .arco-popover-content {
    margin-top: 0;
  }
}
</style>
